<section>
  <!--- Wizard -->
  <div id="title-wizard">
    <ng-container *ngFor="let item of stepslist; let i = index">
      <h1 *ngIf="indexStep === i">{{ item.title | translate }}</h1>
    </ng-container>
  </div>

  <!--- NAV STEPS -->
  <div id="steps-list" class="container">
    <ul>
      <ng-container *ngFor="let item of stepslist; let i = index">
        <li [ngClass]="{ active: indexStep >= i }">{{ item.step | translate }}</li>
      </ng-container>
    </ul>
  </div>

  <!--- FIRST STEP - Your Restaurant -->
  <div *ngIf="indexStep === 0">
    <div class="box-step custom-input">
      <ng-container *ngIf="addressIsValidating">
        <div class="d-flex flex-column m-auto">
          <csa-progress-save-spinner [size]="120" [centered]="true" [strokeWidth]="7"></csa-progress-save-spinner>
          <div class="mx-auto mt-4 mb-4">{{ 'csa.onboarding.address.validation' | translate }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="!addressIsValidating">
        <form [formGroup]="firstFormGroup" (keydown.enter)="$event.preventDefault()">
          <div class="label-title">
            {{ 'csa.your-restaurante' | translate }}
          </div>
          <div *ngIf="firstFormGroup.get('location').invalid && !errorCodes" class="errorBar mb-2">
            {{ 'csa.businessNameError' | translate }}
          </div>
          <div class="row">
            <mat-form-field class="col-md-4 col-sm-4 col-4 col-lg-4">
              <mat-label class="stepper-placeholder">{{ 'csa.enter-business' | translate }} </mat-label>
              <input matInput formControlName="location" required autocomplete="off" />
            </mat-form-field>
            <mat-form-field class="col-md-8 col-sm-8 col-8 col-lg-8 address-container">
              <mat-label class="stepper-placeholder">{{ 'csa.enter-address' | translate }} </mat-label>
              <input
                matInput
                #address
                formControlName="address"
                autocomplete="on"
                autocorrect="off"
                spellcheck="false"
                [attr.data-edge-ignore]="true"
                required />
              <div google-place [initialValue]="firstFormGroup.get('address').value" (placeSelected)="setAddress($event)"></div>
            </mat-form-field>
          </div>
          <div *ngIf="countryMismatchError" class="errorBar mb-2">
            {{ 'csa.yext_invalid_address_country_code' | translate }}
          </div>
          <div class="row">
            <mat-form-field class="col-md-4 col-sm-4 col-4 col-lg-4">
              <mat-label class="stepper-placeholder">{{ 'csa.enter-postal-code' | translate }} </mat-label>
              <input matInput (change)="validateZipCodeOnChange()" maxlength="10" formControlName="postal" autocomplete="off" required />
              <mat-error *ngIf="firstFormGroup.get('postal').invalid">
                {{ 'csa.enter-valid-postal' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-8 col-sm-8 col-8 col-lg-8">
              <mat-label class="stepper-placeholder">{{ 'csa.enter-city' | translate }}</mat-label>
              <input matInput formControlName="city" autocomplete="off" required />
              <mat-error *ngIf="firstFormGroup.get('city').invalid">
                {{ 'csa.enter-value' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row" *ngIf="categoriesAndCountries">
            <mat-form-field class="col-md-4 col-12">
              <mat-label class="stepper-placeholder">{{ 'csa.country' | translate }}</mat-label>
              <mat-select formControlName="country" required (selectionChange)="changeCountry($event)">
                <mat-option>--{{ 'csa.None' | translate }}--</mat-option>
                <mat-option *ngFor="let state of categoriesAndCountries.countries" [value]="state.name">{{ state.name }} </mat-option>
              </mat-select>
              <mat-error *ngIf="firstFormGroup.get('country').invalid">
                {{ 'csa.enter-value' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mb-3 row">
            <div class="col-md-4 col-sm-4 col-4 col-lg-4">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label class="stepper-placeholder">{{ 'csa.area-code' | translate }}</mat-label>
                <mat-select
                  formControlName="area"
                  maxlength="6"
                  autocomplete="off"
                  class="text-right"
                  (selectionChange)="setPhoneCountryCode($event)">
                  <mat-option *ngFor="let c of sortedPhoneNumberCodes" [value]="c">
                    {{ c }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-8 col-sm-8 col-8 col-lg-8">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label class="stepper-placeholder">{{ 'csa.enter-phone' | translate }}</mat-label>
                <input
                  (keypress)="omitSpecialChar($event)"
                  id="phone-input"
                  matInput
                  (focus)="onFocus()"
                  (blur)="onBlur()"
                  formControlName="phone"
                  maxlength="15"
                  minlength="7"
                  autocomplete="off" />
                <mat-error *ngIf="firstFormGroup.get('phone').invalid && !phoneNumberFocused">
                  {{ 'csa.enter-phone-invalid' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
    <ng-container *ngIf="!addressIsValidating">
      <div class="row-btn">
        <div class="container">
          <span>
            <button
              id="goToContactInfoBtn"
              [disabled]="addressIsValidating || firstFormGroup.invalid"
              (click)="goToStepContactInfo(stepper)"
              class="btn btn-next">
              {{ 'csa.next' | translate }}
            </button>
          </span>
        </div>
      </div>
    </ng-container>
  </div>

  <!--- SECOND STEP - Business information -->
  <div *ngIf="indexStep === 1">
    <form [formGroup]="secondFormGroup">
      <div class="box-step custom-input">
        <div class="label-title">
          {{ 'csa.contact-info' | translate }}
        </div>
        <div class="row">
          <mat-form-field class="col-md-4 col-sm-4 col-4 col-lg-4 mb-2">
            <mat-label class="stepper-placeholder">{{ 'csa.enter-email' | translate }}</mat-label>
            <input matInput formControlName="email" autocomplete="off" required />

            <mat-error *ngIf="secondFormGroup.get('email').invalid">
              {{ 'csa.enter-valid-email' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-md-4 col-sm-4 col-4 col-lg-4 mb-2">
            <mat-label class="stepper-placeholder">{{ 'csa.enter-site' | translate }}</mat-label>
            <input matInput formControlName="website" autocomplete="off" />
            <mat-hint>{{ 'csa.example' | translate }}: www.yoursite.com</mat-hint>
            <mat-error *ngIf="secondFormGroup.get('website').hasError('required')">
              {{ 'csa.enter-value' | translate }}
            </mat-error>
            <mat-error *ngIf="secondFormGroup.get('website').hasError('invalidSite')">
              {{ 'csa.enter-valid-site' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col col-lg-6 mb-2">
            <mat-label class="stepper-placeholder">{{ 'csa.enter-description' | translate }} </mat-label>
            <textarea
              class="text-area-description"
              matInput
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              #description
              formControlName="description"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
              autocomplete="off"
              (paste)="onDescriptionPaste($event, secondFormGroup)"
              (input)="onDescriptionInput(secondFormGroup)"
              (blur)="onDescriptionBlur(secondFormGroup)"></textarea>
            <mat-hint *ngIf="!description.value.length" align="start">
              <strong>{{ 'csa.enter-description-text' | translate }}</strong>
            </mat-hint>
            <mat-hint align="end"> {{ secondFormGroup.get('description')?.value?.length || 0 }} / {{ descriptionMaxChars }} </mat-hint>
            <mat-error *ngIf="secondFormGroup.get('description').hasError('validateDescription')">
              {{ 'csa.enter-description-invalid' | translate }}
            </mat-error>
            <mat-error *ngIf="secondFormGroup.get('description').hasError('invalidURL')">
              {{ 'csa.description-invalid-url' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="box-step">
        <div class="wizard-opening-hours" *ngIf="showOpenHoursLayout">
          <open-hours
            [businessOpenTimes]="businessOpenTimes"
            [businessSpecialOpenTimes]="businessSpecialOpenTimes"
            [temporarilyClosed]="temporarilyClosedOpts.OPEN"
            [showSubTitle]="false"
            (storeOpeningTimesEmitter)="onOpeningTimesChange()">
          </open-hours>
        </div>
      </div>
    </form>
    <div class="row-btn">
      <div class="container">
        <button (click)="setStepperIndex(0)" class="btn btn-back">{{ 'csa.back' | translate }}</button>
        <span>
          <button (click)="setStepperIndex(2)" [disabled]="secondFormGroup.invalid" class="btn btn-next">{{ 'csa.next' | translate }}</button>
        </span>
      </div>
    </div>
  </div>

  <!--- THIRD STEP - Your offer -->
  <div *ngIf="indexStep === 2">
    <form [formGroup]="thirdFormGroup">
      <input matInput formControlName="hasSelection" type="text" required style="display: none" />
    </form>

    <div class="container no-padding">
      <generic-attribute-selection
        [content]="availableOfferings"
        [withBorder]="true"
        [isCollapsable]="true"
        (selectedOptions)="onOfferingsChange($event)">
      </generic-attribute-selection>

      <generic-attribute-selection [title]="'csa.services' | translate" [content]="availableServices" (selectedOptions)="onServicesChange($event)">
      </generic-attribute-selection>

      <generic-attribute-selection
        [title]="'csa.payments' | translate"
        [content]="availablePaymentMethods"
        (selectedOptions)="onPaymentsChange($event)">
      </generic-attribute-selection>
    </div>
    <div class="row-btn">
      <div class="container">
        <button (click)="setStepperIndex(1)" class="btn btn-back">{{ 'csa.back' | translate }}</button>
        <span>
          <button (click)="steperchange($event)" class="btn btn-next">{{ 'csa.next' | translate }}</button>
        </span>
      </div>
    </div>
  </div>

  <!--- LAST STEP - Overview -->
  <div *ngIf="indexStep === 3">
    <div class="box-step">
      <p class="text-center">
        <strong>
          {{ 'csa.onboarding.preview.header.basic' | translate }}
        </strong>
      </p>
      <p class="text-center">
        {{ 'csa.onboarding.preview.subheader' | translate }}
      </p>
      <div id="review-google">
        <div id="sim-gallery">
          <span>
            <span>{{ 'csa.clicks.google.see.photos' | translate }}</span>
          </span>
          <span>
            <span>{{ 'csa.clicks.google.see.outside' | translate }}</span>
          </span>
        </div>
        <h2>{{ review.name }}</h2>
        <div id="list-btn">
          <span>{{ 'csa.clicks.google.website' | translate }}</span>
          <span>{{ 'csa.clicks.google.directions' | translate }}</span>
          <span>{{ 'csa.review.save' | translate }}</span>
        </div>
        <p>{{ review.description }}</p>
        <ul>
          <li>
            <strong>{{ 'csa.enter-address' | translate }}:</strong> {{ review.street }}
          </li>
          <li>
            <strong>{{ 'csa.clicks.google.see.hours' | translate }}:</strong>
            <div>
              <button (click)="showWeek()">
                <span [style.color]="review.openColor">{{ review.openStatus }}</span> {{ review.now }}
              </button>
              <ul *ngIf="keyShowWeek">
                <li *ngFor="let item of review.hour">
                  <strong>{{ item.day }}: </strong>{{ item.hour }}
                </li>
              </ul>
            </div>
          </li>
          <li>
            <strong>{{ 'csa.enter-phone' | translate }}:</strong> {{ review.phone }}
          </li>
          <li>
            <strong>{{ 'csa.enter-site' | translate }}:</strong> {{ review.url }}
          </li>
          <li>
            <strong>{{ 'cuisineTypes' | translate }}:</strong> {{ review.offerings }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row-btn">
      <div class="container">
        <button (click)="setStepperIndex(2)" class="btn btn-back">{{ 'csa.back' | translate }}</button>
        <span>
          <form (ngSubmit)="save(firstFormGroup, secondFormGroup, formConclusion)">
            <button *ngIf="indexStep !== 3" class="btn btn-next" type="submit">{{ 'csa.next' | translate }}</button>
            <button *ngIf="indexStep === 3" class="btn btn-next" type="submit">{{ 'csa.onboarding.submit.button' | translate }}</button>
          </form>
        </span>
      </div>
    </div>
  </div>
</section>
